import React, { useState, useEffect } from 'react'
import { Input, Grid, InputGroup, TagGroup, Tag, Row } from 'rsuite'
import { isValidators } from '../../utils/ValidatorUtils'

export default function SearchTagForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  //useState
  const [schema, setSchema] = useState(_schema)
  const [tagList, setTagList] = useState(schema.searchTag.values)
  const [inputValue, setInputValue] = useState('')

  const handleInputConfirm = () => {
    let _tagList = [...tagList]

    let newId = `ADD_ID_${new Date().getTime()}`
    inputValue && _tagList.push({ id: newId, value: inputValue, isDelete: false })

    setInputValue('')
    setTagList(_tagList)
    setValue(schema.searchTag.name, _tagList)
  }

  const handleTagRemove = (tag) => {
    const newTagList = tagList.filter((item) => item !== tag)
    setTagList(newTagList)
    setValue(schema.searchTag.name, newTagList)
  }

  return (
    <Grid>
      <Controller
        key={schema.searchTag.name}
        name={schema.searchTag.name}
        control={control}
        defaultValue={tagList}
        rules={isValidators(schema.searchTag.validators)}
      />
      {errors[schema.searchTag.name] && (
        <Row style={{ marginBottom: 10 }}>
          <ErrorMessage error={errors[schema.searchTag.name]} />
        </Row>
      )}

      <InputGroup style={{ width: 300 }}>
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e)}
          placeholder={schema.searchTag.hint}
          onPressEnter={() => handleInputConfirm()}
        />
        <InputGroup.Button onClick={() => handleInputConfirm()}>
          <label>{schema.searchTag.postLabel}</label>
        </InputGroup.Button>
      </InputGroup>

      <br />

      <TagGroup>
        {tagList.map((item, index) => (
          <Tag
            key={index}
            closable
            color="orange"
            onClose={() => {
              handleTagRemove(item)
            }}
          >
            {item.value}
          </Tag>
        ))}
      </TagGroup>
    </Grid>
  )
}
